module.exports = __webpack_public_path__ + "media/images/pages/ic-chevron-down-79a9370fe3cf90413425c13b960a00cc.png";